import {
  getProductConfig,
  type QuoteWizardFlow,
} from '@/app/config/products.config';
import type { SummaryQuotes } from '@/services/quotes/types';
import { PortalStatus } from '@/shared/enums/portal-status.enum';

export function isCapitalGlobalQuoteFromSummary(
  quote: Pick<SummaryQuotes, 'productName'>
): boolean {
  const name = (quote.productName || '').toLowerCase();
  return name.includes('capital global');
}

export function isCapitalGlobalQuoteProduct(
  productCode?: string | null
): boolean {
  if (!productCode?.trim()) return false;
  return getProductConfig(productCode)?.usesCapitalGlobalProposal === true;
}

export function resolveCapitalGlobalQuoteListActions(status: number): {
  canViewDetails: boolean;
  canEdit: boolean;
  canClone: boolean;
} {
  const isInProgress = status === PortalStatus.QuoteInProgress;
  const isCalculated = status === PortalStatus.QuoteCalculated;

  return {
    canViewDetails: !isInProgress,
    canEdit: isInProgress,
    canClone: isInProgress || isCalculated,
  };
}

export function resolveCapitalGlobalQuoteWizardRedirect(input: {
  statusPortal: number | string | undefined;
  mode: 'view' | 'edit';
}): { stepCode: string; quoteFlow: QuoteWizardFlow } {
  const status = Number(input.statusPortal) || 0;

  if (input.mode === 'edit') {
    if (status === PortalStatus.QuoteCalculated) {
      return { stepCode: 'CALCULATION', quoteFlow: 'view' };
    }

    return { stepCode: '', quoteFlow: 'edit' };
  }

  if (status === PortalStatus.QuoteInProgress) {
    return { stepCode: '', quoteFlow: 'edit' };
  }

  return { stepCode: 'CALCULATION', quoteFlow: 'view' };
}

export function canEditCapitalGlobalQuoteByStatus(
  statusPortal: number | string | undefined
): boolean {
  return Number(statusPortal) === PortalStatus.QuoteInProgress;
}

export function isCapitalGlobalCalculatedQuoteViewMode(input: {
  statusPortal: number | string | undefined;
  quoteFlow: QuoteWizardFlow;
}): boolean {
  return (
    input.quoteFlow === 'view' &&
    Number(input.statusPortal) === PortalStatus.QuoteCalculated
  );
}
